import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import ServicesSection from './components/ServicesSection';
import TopCoachesSection from './components/TopCoachesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

export default function Home() {
  useSEO({
    title: 'CoachFit - Trouvez votre coach sportif à domicile en France',
    description: 'Trouvez le coach sportif parfait près de chez vous. Plus de 150 coachs certifiés pour du fitness à domicile, musculation, yoga, nutrition. Réservation en ligne simple et rapide avec paiement sécurisé.',
    keywords: 'coach sportif, fitness domicile, musculation, yoga, nutrition, entraîneur personnel, coaching sportif, sport à domicile, coach personnel',
    canonical: '/',
    ogImage: 'https://public.readdy.ai/ai/img_res/da0b8fa63c40e552541c080ae7451b0d.jpg',
    schema: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "CoachFit",
      "description": "Plateforme de coaching sportif à domicile avec des coachs certifiés en France",
      "url": `${import.meta.env.VITE_SITE_URL || ''}/`,
      "telephone": "+33-4-91-23-45-67",
      "email": "fabio-coaching-sportif@hotmail.fr",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "10 rue Saint Eloi",
        "addressLocality": "Marseille",
        "postalCode": "13010",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "43.296482",
        "longitude": "5.369780"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "16:00"
        }
      ],
      "priceRange": "€€",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1247",
        "bestRating": "5",
        "worstRating": "1"
      },
      "sameAs": [
        "https://www.facebook.com/coachfit",
        "https://www.instagram.com/coachfit"
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <ServicesSection />
        <TopCoachesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
